import React from 'react';

import {
  Box,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  HStack,
  Icon,
  IconButton,
  Stack,
  useColorModeValue,
  useDisclosure,
} from '@ecoinvent/ui';
import { MdMenu } from 'react-icons/md';
import { Link as RouterLink } from 'react-router';

import logoWhite from 'assets/ecoQuery-white.svg';
import logo from 'assets/ecoQuery.svg';
import useVersionInfo from 'hooks/useVersionInfo';

import SidebarContent from '../SideBarContent';

const MobileSideBar = () => {
  const { system_model, ver } = useVersionInfo();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bg = useColorModeValue('white', 'whiteAlpha.50');

  const logoSrc = useColorModeValue(logo, logoWhite);

  return (
    <Stack as="nav">
      <HStack display={{ base: 'flex', md: 'none' }} p={3} bg={bg}>
        <IconButton color="inherit" aria-label="open drawer" onClick={onOpen} variant={'ghost'} icon={<Icon as={MdMenu} />} />
        <Box maxW={'153px'}>
          <RouterLink to={`/${ver}/${system_model}`}>
            <img className="logo" alt="logo" src={logoSrc} />
          </RouterLink>
        </Box>
      </HStack>
      <Drawer isOpen={isOpen} onClose={onClose} placement="left">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton top="21px" right="9px" />
          <SidebarContent onLinkClick={onClose} />
        </DrawerContent>
      </Drawer>
    </Stack>
  );
};

export default MobileSideBar;
